module.exports = __webpack_public_path__ + "img/_cross-resonance_.05e4858f.svg";